import React from "react";
const MilestoneCompletion = ({ milestones,loader }) => {
  return (
    <div className="p-6 bg-white rounded-2xl shadow-md w-full h-[428px] overflow-y-auto pr-2 scrollbar-hide">

      {loader ?
        <div className="h-[350px] flex items-center justify-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
        </div>
         :
        (milestones && milestones.length > 0) ? milestones.map((milestone, index) => {
          let bgColor = milestone.completion >= '80%' ? '#16A34A' : milestone.completion >= '60%' ? '#1D4ED8' : milestone.completion >= '40%' ? '#FFA21D' : '#EA580C'
          return (
            <div key={index} className="mb-4 py-3">
              <div className="flex justify-between mb-1">
                <span className="text-sm font-medium text-gray-700">{milestone.milestone}</span>
                <span className="text-sm font-medium text-gray-700">{milestone.completion}</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-3">
                <div
                  className={`
               h-3 rounded-full`}
                  style={{ width: `${milestone.completion}`, background: bgColor }}
                ></div>
              </div>
            </div>
          )
        }) :
          <div className="text-center h-[428px] content-center">
            <p className="text-gray-400 text-sl">There are currently no Milestone Completion.</p>
          </div>
      }
    </div>
  );
};

export default MilestoneCompletion;
